export const CITY_MAX_LENGTH = 24;
